import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "frm-spinner" }
const _hoisted_2 = { class: "flex items-center bg-white p-3 rounded-full shadow-md" }

import { IonSpinner } from '@ionic/vue';
 
 
export default /*#__PURE__*/_defineComponent({
  __name: 'PageLoader',
  setup(__props) {

 
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(IonSpinner), { name: "circles" })
    ])
  ]))
}
}

})